const servicoagrupado = (state = [], action) => {
    switch (action.type) {
      case 'SERVICOAGRUPADO':
      return {
          type: "SERVICOAGRUPADO",
          servicoagrupado: action.servicoagrupado
        }
      default:
        return state
    }
  }
  
  export default servicoagrupado